import { GoodDetailParam } from '../../../../pages/shop/c_shop/component';
import { CommonHeaders, SHOPURL } from '../../../../pages/shop/c_shop/utils/service';

export async function MultiSkuRequest(requestParam: GoodDetailParam, headers = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const params = {
    url: SHOPURL.MULTISKU,
    method: 'POST',
    data: requestParam,
    dataType: 'json',
    headers: {
      ...CommonHeaders.getCommonHeader(),
      ...headers
    },
  };

  // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.error) {
        console.log(`MultiSkuRequest request api error: ${JSON.stringify(result.error)}`);
        reject(result.error);
      } else {
        console.log('MultiSkuRequest request api success!');
        if (result.data && result.data.code === 0 && result.data.data) {
          resolve(result.data.data);
        } else {
          reject(result);
        }
      }
    });
  });
}
